// extracted by mini-css-extract-plugin
export default {"root":"mbgTsy17AaeJPYyGAJdn"};